import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01ec8dd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "mb-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-10 fs-15 fs-md-16 fs-lg-18" }, "Admisión grupal", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "flt-student",
  class: "form-label fw-medium text-black"
}, "Estudiante", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "flt-headquarter",
  class: "form-label fw-medium text-black"
}, "Sede", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "flt-group",
  class: "form-label fw-medium text-black"
}, "Grupo asignado", -1))
const _hoisted_8 = {
  class: "accordion",
  id: "tableOfContentAccordion"
}
const _hoisted_9 = ["data-bs-target", "aria-controls"]
const _hoisted_10 = { class: "d-sm-flex align-items-center justify-content-between w-100" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "number bg-primary text-center text-white rounded-circle fs-13 fw-semibold" }
const _hoisted_13 = { class: "ms-10" }
const _hoisted_14 = { class: "text-muted ms-10" }
const _hoisted_15 = { class: "d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled" }
const _hoisted_16 = { class: "position-relative fw-medium fs-14 text-muted me-15" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book" }, null, -1))
const _hoisted_18 = { class: "position-relative fw-medium fs-14 text-muted me-15" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-clock" }, null, -1))
const _hoisted_20 = { class: "position-relative fw-medium fs-14 text-muted" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "accordion-body" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "text-center text-success my-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Cargando...", -1))
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "d-block fw-bold text-primary" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "d-flex justify-content-between align-items-center px-3 pb-3" }
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = {
  key: 0,
  class: "text-muted fs-14 mt-10"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputYear",
  class: "form-label fw-medium text-black"
}, "Año académico", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputHq",
  class: "form-label fw-medium text-black"
}, "Sede", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputGroup",
  class: "form-label fw-medium text-black"
}, "Grupo asignado", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputEnrollmentDate",
  class: "form-label fw-medium text-black"
}, " Fecha registro de admisión ", -1))
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_FormatDateTimeRow = _resolveComponent("FormatDateTimeRow")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_b_row, { class: "g-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, { md: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createVNode(_component_SearchSelect, {
                      id: "flt-student",
                      modelValue: _ctx.filters.studentId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.studentId) = $event)),
                      options: _ctx.studentOptions,
                      placeholder: "Seleccione el estudiante",
                      onChange: _ctx.onFiltersChange
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_col, { md: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_SearchSelect, {
                      id: "flt-headquarter",
                      modelValue: _ctx.filters.headquarterId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.headquarterId) = $event)),
                      options: _ctx.headquarterOptions,
                      placeholder: "Seleccione la sede",
                      onChange: _ctx.onFiltersChange
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_b_col, { md: "4" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createVNode(_component_SearchSelect, {
                      id: "flt-group",
                      modelValue: _ctx.filters.courseGroupId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.courseGroupId) = $event)),
                      options: _ctx.groupOptions,
                      placeholder: "Seleccione el grupo",
                      onChange: _ctx.onFiltersChange
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedByGroup, (grp, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: grp.groupId,
            class: "accordion-item border-0"
          }, [
            _createElementVNode("button", {
              class: "accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fs-lg-16 fw-medium rounded-0 bg-white border-0",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#collapse-${grp.groupId}`,
              "aria-controls": `collapse-${grp.groupId}`
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(idx + 1), 1),
                  _createElementVNode("span", _hoisted_13, [
                    _createTextVNode(_toDisplayString(grp.groupName || ("Grupo " + grp.groupId)) + " ", 1),
                    _createElementVNode("span", _hoisted_14, " — " + _toDisplayString(grp.headquarterName || "Sin sede") + " · Año: " + _toDisplayString(grp.academicYearNameDisplay), 1)
                  ])
                ]),
                _createElementVNode("ul", _hoisted_15, [
                  _createElementVNode("li", _hoisted_16, [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(grp.counts.total) + " estudiantes ", 1)
                  ]),
                  _createElementVNode("li", _hoisted_18, [
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(grp.counts.enrolled) + " matriculados ", 1)
                  ]),
                  _createElementVNode("li", _hoisted_20, [
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(grp.counts.unenrolled) + " sin matricular ", 1)
                  ])
                ])
              ])
            ], 8, _hoisted_9),
            _createElementVNode("div", {
              id: `collapse-${grp.groupId}`,
              class: "accordion-collapse collapse",
              "data-bs-parent": "#tableOfContentAccordion"
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_b_table, {
                    items: grp.items,
                    fields: _ctx.groupTableHeaders,
                    class: "table table-sm table-ultra-compact text-nowrap mb-0",
                    hover: "",
                    small: "",
                    onRowClicked: _ctx.onRowClicked
                  }, {
                    "table-busy": _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_b_spinner, { class: "align-middle" }),
                        _hoisted_26
                      ])
                    ]),
                    "cell(Selected)": _withCtx(({ item }) => [
                      _createVNode(_component_b_form_checkbox, {
                        modelValue: item.Selected,
                        "onUpdate:modelValue": ($event: any) => ((item.Selected) = $event),
                        name: "checkbox-enable"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    "cell(StudentName)": _withCtx(({ item }) => [
                      _createElementVNode("a", {
                        onClick: _withModifiers(($event: any) => (_ctx.editStudent(item.StudentId)), ["prevent"]),
                        class: "cursor-pointer text-black fw-bold text-decoration-none"
                      }, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(item.StudentName), 1)
                      ], 8, _hoisted_27)
                    ]),
                    "cell(EnrollmentDateFormat)": _withCtx(({ item }) => [
                      _createVNode(_component_FormatDateTimeRow, {
                        value: item.EnrollmentDate,
                        mode: "date"
                      }, null, 8, ["value"])
                    ]),
                    "cell(Status)": _withCtx(({ item }) => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge badge-compact", _ctx.normalizeStatus(item.Status) === 'MATRICULADO'
                      ? 'text-outline-success'
                      : 'text-outline-secondary'
                      ])
                      }, _toDisplayString(item.Status), 3)
                    ]),
                    "cell(action)": _withCtx(({ item }) => [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: ($event: any) => (_ctx.editEnrollment(item.Id)),
                        class: "bg-transparent p-0 border-0 btn-icon",
                        "aria-label": "Editar",
                        title: "Ver matrícula"
                      }, _hoisted_31, 8, _hoisted_29)
                    ]),
                    _: 2
                  }, 1032, ["items", "fields", "onRowClicked"])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("small", _hoisted_33, " Seleccionados: " + _toDisplayString(grp.items.filter(
                    (x) =>
                      x.Selected && _ctx.normalizeStatus(x.Status) !== "MATRICULADO"
                  ).length) + " / " + _toDisplayString(grp.counts.unenrolled) + " posibles ", 1),
                _createVNode(_component_b_button, {
                  type: "button",
                  class: "btn btn-success",
                  disabled: _ctx.table.loading,
                  onClick: ($event: any) => (_ctx.openDialog(grp)),
                  style: `--bs-btn-padding-y: .25rem; --bs-btn-padding-x: .75rem; --bs-btn-font-size: .8rem;`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Registrar admisiones ")
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ])
            ], 8, _hoisted_22)
          ]))
        }), 128)),
        (!_ctx.groupedByGroup.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, " No hay datos para mostrar. "))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_b_modal, {
        class: "modal fade",
        modelValue: _ctx.form.dialog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.dialog) = $event)),
        tabindex: "-1",
        "aria-hidden": "true",
        title: "Registrar matrícula grupal",
        "ok-disabled": "",
        "hide-footer": true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_container, {
            fluid: "",
            class: "p-15 p-sm-20 p-md-25 p-lg-30"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form, {
                ref: "formRecord",
                id: "formModal",
                onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_35,
                              _createVNode(_component_SearchSelect, {
                                id: "inputYear",
                                modelValue: _ctx.form.record.AcademicYearId,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.AcademicYearId) = $event)),
                                required: "",
                                loading: _ctx.table.loading,
                                options: _ctx.academicYears.map(r => ({
                      value: r.Id,
                      text: `Año ${r.Year} - Período: ${r.StartDate.substring(
                        0,
                        10
                      )} Hasta ${r.EndDate.substring(0, 10)}`
                    }))
                      ,
                                placeholder: "Seleccione el año académico",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "loading", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_36,
                              _createVNode(_component_SearchSelect, {
                                id: "inputHq",
                                modelValue: _ctx.form.record.HeadquarterId,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.HeadquarterId) = $event)),
                                required: "",
                                loading: _ctx.table.loading,
                                options: _ctx.headquarters.map(r => ({ value: r.Id, text: `${r.Description}` })),
                                placeholder: "Seleccione la sede",
                                onChange: _ctx.changeValuesLoad
                              }, null, 8, ["modelValue", "loading", "options", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_37,
                              _createVNode(_component_SearchSelect, {
                                id: "inputGroup",
                                modelValue: _ctx.form.record.CourseGroupId,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.CourseGroupId) = $event)),
                                required: "",
                                loading: _ctx.table.loading,
                                options: _ctx.coursesGroupAvailable.map(r => ({ value: r.Id, text: r.Name })),
                                placeholder: "Seleccione el grupo"
                              }, null, 8, ["modelValue", "loading", "options"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_col, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_group, null, {
                            default: _withCtx(() => [
                              _hoisted_38,
                              _createVNode(_component_b_form_input, {
                                id: "inputEnrollmentDate",
                                class: "form-control fs-14 text-black shadow-none form-control-sm",
                                modelValue: _ctx.form.record.EnrollmentDate,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record.EnrollmentDate) = $event)),
                                type: "date",
                                required: ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_b_form_invalid_feedback, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Campo requerido")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_row, {
                    dense: "",
                    class: "mt-3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, {
                        cols: "12",
                        sm: "6"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_button, {
                            type: "submit",
                            class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                            disabled: _ctx.form.loading
                          }, {
                            default: _withCtx(() => [
                              (!_ctx.form.loading)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_39, "Registrar admisiones"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_40, "Registrando..."))
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}